import React, { useContext } from "react";
import { RicosViewerContext } from "./../../ricos-context";
import styles from "../statics/styles/default-styles-scss";
import { ACTION_BUTTON_TYPE, LINK_BUTTON_TYPE } from "../types";
import { ButtonViewer } from "./button-viewer";
const Button = ({ node, nodeIndex, NodeViewContainer }) => {
  const { helpers, config, onNodeClick, baseUrl } = useContext(RicosViewerContext);
  const settings = node.buttonData?.type === "ACTION" ? config[ACTION_BUTTON_TYPE] : config[LINK_BUTTON_TYPE];
  return /* @__PURE__ */ React.createElement(NodeViewContainer, { key: node.id, node, nodeIndex }, /* @__PURE__ */ React.createElement(
    ButtonViewer,
    {
      nodeId: node.id,
      helpers,
      settings,
      buttonData: node.buttonData,
      onClick: () => onNodeClick?.({ node }),
      baseUrl,
      className: styles.button_margin
    }
  ));
};
var button_default = Button;
export {
  button_default as default
};
//# sourceMappingURL=button.js.map

import "@wix/ricos/css/plugin-button-viewer.global.css";